import React from 'react';

import { SignatureForm } from '../../Form/Forms';

export default () => (
  <div className="signature-content form-content">
    <SignatureForm />
  </div>
);
